import { BrowserBranding } from "./types.ts";
import logoSquareSvg from "../assets/main/logo-square.svg";
import loadingSquareAnimation from "../assets/main/loading-logo-square.webp";
import logoSquareBitmap from "../assets/main/logo.png";
import purposeMyself from "../assets/main/get-started/whositfor-myself.png";
import purposeGift from "../assets/main/get-started/whosifor-gift.png";
import giftTypeBrickMosaic from "../assets/main/get-started/typeofgift-brickmosaic.png";
import giftTypeGiftCard from "../assets/main/get-started/typeofgift-giftcard.png";
import giftChooserIChoose from "../assets/main/get-started/typeofgift-ichoose.webp";
import giftChooserTheyChoose from "../assets/main/get-started/typeofgift-theychoose.webp";

function createMainBrowserBranding(): BrowserBranding {
	return {
		showPoweredBy: false,
		companyName: "Brick Me",
		domainName: "brick.me",
		logoSquareSvg,
		loadingSquareAnimation,
		logoSquareBitmap,
		giftCardProductPath: "/products/brick-me-gift-card",
		mosaicGiftPagePath: "/pages/mosaic-gift",
		readOurTipsPath:
			"/blogs/inspiration/6-tips-to-find-the-best-pics-to-brick/",
		contactPagePath: "/pages/contact-us",
		faqPagePath: "/pages/frequently-asked-questions",
		designItForMeProductPath: "/products/design-it-for-me-service",
		picsToBrickTipsHeading: "What pics are best to brick?",
		showBrickMosaicGiftOption: true,
		showGiftCardAmountText: true,
		minimumGiftCardAmount: 50,
		getStartedImages: {
			purposeMyself,
			purposeGift,
			giftTypeBrickMosaic,
			giftTypeGiftCard,
			giftChooserIChoose,
			giftChooserTheyChoose,
		},
	};
}

export { createMainBrowserBranding };
